import React, { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent("agrinova-install-available"));
  });
}

export default function InstallPrompt() {
  const { t } = useI18n();
  const [available, setAvailable] = useState(!!deferredPrompt);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("agrinova_install_dismissed") === "1"
  );

  useEffect(() => {
    const onAvailable = () => setAvailable(true);
    window.addEventListener("agrinova-install-available", onAvailable);
    return () => window.removeEventListener("agrinova-install-available", onAvailable);
  }, []);

  if (!available || dismissed) return null;

  async function install() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setAvailable(false);
    }
    deferredPrompt = null;
  }

  function dismiss() {
    localStorage.setItem("agrinova_install_dismissed", "1");
    setDismissed(true);
  }

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-md rounded-xl border border-border bg-card shadow-lg p-4 flex items-center gap-3"
      data-testid="install-banner"
    >
      <img src="/logo-agrinova.png" alt="AgriNova" className="w-10 h-10 rounded-lg object-cover shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">{t("install_app")}</div>
        <div className="text-xs text-muted-foreground truncate">{t("install_hint")}</div>
      </div>
      <Button size="sm" onClick={install} data-testid="install-btn">
        <Download className="w-4 h-4 mr-1" />{t("install")}
      </Button>
      <button onClick={dismiss} aria-label={t("cancel")} data-testid="install-dismiss"
        className="w-8 h-8 rounded-lg flex items-center justify-center text-muted-foreground hover:bg-secondary transition-colors shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
